import { isPointInPolygon } from "../../selectionAreas";
import { polygonArea } from "../../polygonArea";
import type { FindRoomAtPoint } from "./types";

// Overlapping rooms resolve to the smallest one under the point, the more specific choice.
export const findRoomAtPoint: FindRoomAtPoint = ({ rooms, point }) =>
  rooms.reduce(
    (smallest, room) => {
      if (!isPointInPolygon({ point, ring: room.points })) return smallest;
      if (smallest === null) return room;
      return polygonArea(room.points) < polygonArea(smallest.points)
        ? room
        : smallest;
    },
    null as (typeof rooms)[number] | null,
  );
